"use client";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";
import { allProductDetails } from "@/util/view/header/components/MenuProducts";
import Image from "next/image";

import Link from "next/link";

const ProductsPopular = () => {
    return (
        <div className="bg-main">
            <div className="sm:container">
                <p className="font-bold sm:text-2xl text-base text-text p-2">پرفروش ترین عطر ها</p>
                <Carousel
                    opts={{
                        align: "start",
                        loop: true,
                        direction: "rtl",
                    }}
                    className="w-full"
                >
                    <CarouselContent className="-ml-2 md:-ml-4">
                        {allProductDetails?.map((item, index) => (
                            <CarouselItem
                                key={index}
                                className="pl-2 basis-1/2 lg:basis-1/3 xl:basis-1/6"
                            >
                                <Link href={`${item.src}`} className="relative h-[240px] w-[180px] block my-2 text-center">
                                    <div className="relative h-[210px]">
                                        <p className="absolute z-10 rounded-lg  bottom-[-25px] shadow-md left-1/2 transform -translate-x-1/2 -translate-y-[50%]   py-1 bg-main2 text-test text-[13px] font-semibold truncate w-[90%] px-1">
                                            {item.title}
                                        </p>
                                        <Image
                                            alt={item.alt || item.title}
                                            src={item.img}
                                            fill
                                            className="object-contain w-full"
                                        />
                                    </div>
                                </Link>

                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious />
                    <CarouselNext />
                </Carousel>
            </div>
        </div>
    )
}

export default ProductsPopular